import { create } from "zustand";
import { fetchLobbyRooms } from "./lobbyApi";
import type { LobbyRoom, LobbyStatus } from "./types";

interface RoomState {
  status: LobbyStatus;
  /** Каталог в порядке ответа сервера. Не сохраняется между загрузками. */
  rooms: LobbyRoom[];
  selectedRoom: LobbyRoom | null;
  loadRooms: () => Promise<void>;
  selectRoom: (room: LobbyRoom) => void;
  /** Возврат к каталогу с повторным запросом (§8). */
  backToCatalog: () => void;
}

export const useRoomStore = create<RoomState>((set, get) => ({
  status: "idle",
  rooms: [],
  selectedRoom: null,

  loadRooms: async () => {
    if (get().status === "loading") return;
    set({ status: "loading" });
    try {
      const rooms = await fetchLobbyRooms();
      set({ status: "ready", rooms });
    } catch (error) {
      // Ошибка каталога не откатывается на сохранённый список, комнату по
      // умолчанию или старый общий адрес (§7).
      console.warn("rooms: каталог недоступен", error);
      set({ status: "error", rooms: [] });
    }
  },

  selectRoom: (room) => set({ selectedRoom: room }),

  backToCatalog: () => {
    set({ selectedRoom: null, rooms: [], status: "idle" });
    void get().loadRooms();
  },
}));
